import React from 'react';
import styles from './styles.module.scss';
import { ProductType } from '../../types';
import SavingsSummary from '../SavingsSummary';
import { trackCallButtonClick } from '../../utils/tracking';

interface SuccessSlideProps {
  productType: ProductType;
  zipFlag: boolean | null;
  zipCode?: string;
}

/**
 * Slide di successo dopo l'invio del form
 */
const SuccessSlide: React.FC<SuccessSlideProps> = ({
  productType,
  zipFlag,
  zipCode,
}) => {
  const handleCallClick = () => {
    trackCallButtonClick();
  };

  return (
    <div className={styles.successSlide}>
      <h3 className={styles.successMainTitle}>
        Approfitta subito dei Bonus, ti chiamiamo a breve da un numero di
        cellulare.
      </h3>

      <p className={styles.successSubtitle}>
        Alternativamente puoi contattarci già tu cliccando su{' '}
        <a
          href="tel:00393476331490"
          className={styles.callNowLink}
          onClick={handleCallClick}
        >
          "Chiamaci Ora"
        </a>
        .
      </p>

      <SavingsSummary productType={productType} zipFlag={zipFlag} zipCode={zipCode} />
    </div>
  );
};

export default SuccessSlide;
